import * as React from 'react';
import { PageWrap } from '../../layouts';
import { LottieWrapper } from './index';

const NoContentPage: React.FC<{}> = () => {
  return (
    <PageWrap alignItems="center" flexDirection="column" justifyContent="center">
      <LottieWrapper width={400} height={'auto'} loop={true} anim={require('../../assets/lottie/me_at_office.json')} />
      This page is currently being worked on. It will be available soon.
    </PageWrap>
  );
};

export default NoContentPage;
